import Vue from 'vue';

export default {
	changeView(state, name) {
		setViewId(state, state.views.indexOf(name));
	},

	changeViewId(state, id) {
		setViewId(state, id);
	},

	registerPlugin(state, [pluginName, worker, promise]) {
		if (pluginName) {
			if (!state.plugins.hasOwnProperty(pluginName)) {
				state.plugins = {
					...state.plugins,
					[pluginName]: {
						worker,
						promise,
						functionalities: [],
						ready: false
					}
				};

				console.log('registered plugin with name', pluginName, worker);
			}
		}
	},

	pluginPromise_addOn(state, [pluginName, event, func]) {
		if (pluginName && state.plugins.hasOwnProperty(pluginName)) {
			if (state.plugins[pluginName].promise.on.hasOwnProperty(event)) {
				state.plugins[pluginName].promise.on[event].push(func);

				state.plugins = {
					...state.plugins
				};
			}
		}
	},
	pluginPromise_removeOn(state, [pluginName, event, func]) {
		if (pluginName && state.plugins.hasOwnProperty(pluginName)) {
			if (state.plugins[pluginName].promise.on.hasOwnProperty(event)) {
				state.plugins[pluginName].promise.on[event].splice(
					state.plugins[pluginName].promise.on[event].indexOf(func),
					1
				);

				state.plugins = {
					...state.plugins
				};
			}
		}
	},

	pluginPromise_addOnce(state, [pluginName, event, func]) {
		if (pluginName && state.plugins.hasOwnProperty(pluginName)) {
			if (state.plugins[pluginName].promise.once.hasOwnProperty(event)) {
				state.plugins[pluginName].promise.once[event].push(func);

				state.plugins = {
					...state.plugins
				};
			}
		}
	},
	pluginPromise_removeOnce(state, [pluginName, event, func]) {
		if (pluginName && state.plugins.hasOwnProperty(pluginName)) {
			if (state.plugins[pluginName].promise.once.hasOwnProperty(event)) {
				state.plugins[pluginName].promise.once[event].splice(
					state.plugins[pluginName].promise.once[event].indexOf(func),
					1
				);

				state.plugins = {
					...state.plugins
				};
			}
		}
	},

	pluginPromise_addOnId(state, [pluginName, id, func]) {
		if (pluginName && state.plugins.hasOwnProperty(pluginName)) {
			if (!state.plugins[pluginName].promise.onId.hasOwnProperty(id)) {
				state.plugins[pluginName].promise.onId[id] = [];
			}
			state.plugins[pluginName].promise.onId[id].push(func);

			state.plugins = {
				...state.plugins
			};
		}
	},
	pluginPromise_removeOnId(state, [pluginName, id, func]) {
		if (pluginName && state.plugins.hasOwnProperty(pluginName)) {
			if (state.plugins[pluginName].promise.onId.hasOwnProperty(id)) {
				state.plugins[pluginName].promise.onId[id].splice(
					state.plugins[pluginName].promise.onId[id].indexOf(func),
					1
				);

				state.plugins = {
					...state.plugins
				};
			}
		}
	},

	pluginPromise_addOnceId(state, [pluginName, id, func]) {
		if (pluginName && state.plugins.hasOwnProperty(pluginName)) {
			if (!state.plugins[pluginName].promise.onceId.hasOwnProperty(id)) {
				state.plugins[pluginName].promise.onceId[id] = [];
			}
			state.plugins[pluginName].promise.onceId[id].push(func);

			state.plugins = {
				...state.plugins
			};
		}
	},
	pluginPromise_removeOnceId(state, [pluginName, id, func]) {
		if (pluginName && state.plugins.hasOwnProperty(pluginName)) {
			if (state.plugins[pluginName].promise.onceId.hasOwnProperty(id)) {
				state.plugins[pluginName].promise.onceId[id].splice(
					state.plugins[pluginName].promise.onceId[id].indexOf(func),
					1
				);

				state.plugins = {
					...state.plugins
				};
			}
		}
	},

	pluginSetDeclaredFunctionalities(
		state,
		[pluginName, declaredFunctionalities]
	) {
		let functionalities = [];

		for (
			let functionalityI = 0;
			functionalityI < declaredFunctionalities.length;
			functionalityI++
		) {
			let functionality = declaredFunctionalities[functionalityI];

			if (typeof functionality === 'string') {
				if (
					[
						'install',
						'renderMsgBody',
						'resourceExts',
						'inputExts',
						'newMsg',
						'displayNotification'
					].indexOf(functionality) !== -1
				) {
					functionalities.push(functionality);
				}
			}
		}

		console.log(
			'setting declared functionalities',
			pluginName,
			declaredFunctionalities,
			functionalities
		);

		state.plugins = {
			...state.plugins,
			[pluginName]: {
				...state.plugins[pluginName],
				functionalities: functionalities
			}
		};
	},

	pluginReady(state, pluginName) {
		if (pluginName) {
			state.plugins = {
				...state.plugins,
				[pluginName]: {
					...state.plugins[pluginName],
					ready: true
				}
			};
		}
	},

	pluginSetResourceExts(state, [pluginName, resourceExts]) {
		let compiledResourceExts = [];

		for (
			let resourceExtI = 0;
			resourceExtI < resourceExts.length;
			resourceExtI++
		) {
			let resourceExt = resourceExts[resourceExtI];
			let componentObj = new Function(
				resourceExt.component.args,
				resourceExt.component.body
			);
			console.log(
				'componentObj',
				resourceExt,
				typeof componentObj,
				componentObj
			);
			compiledResourceExts.push({
				name: resourceExt.name,
				component: Vue.component(
					resourceExt.name,
					componentObj(pluginName, state.plugins[pluginName])
				)
			});
		}

		console.log(
			'setting resource exts',
			pluginName,
			resourceExts,
			compiledResourceExts
		);

		state.plugins = {
			...state.plugins,
			[pluginName]: {
				...state.plugins[pluginName],
				resourceExts: compiledResourceExts
			}
		};
	},

	pluginSetInputExts(state, [pluginName, inputExts]) {
		let compiledInputExts = [];

		for (let inputExtI = 0; inputExtI < inputExts.length; inputExtI++) {
			let inputExt = inputExts[inputExtI];
			let componentObj = new Function(
				inputExt.component.args,
				inputExt.component.body
			);
			console.log(
				'componentObj',
				inputExt,
				typeof componentObj,
				componentObj
			);
			compiledInputExts.push({
				name: inputExt.name,
				component: Vue.component(
					inputExt.name,
					componentObj(pluginName, state.plugins[pluginName])
				)
			});
		}

		console.log(
			'setting input exts',
			pluginName,
			inputExts,
			compiledInputExts
		);

		state.plugins = {
			...state.plugins,
			[pluginName]: {
				...state.plugins[pluginName],
				inputExts: compiledInputExts
			}
		};
	}
};

function setViewId(state, id) {
	if (!state.views[id]) {
		console.debug('viewId ', id, ' invalid!');
	} else {
		state.curViewId = id;
	}
}
